import {
    REQUEST_CUSTOMER_DATA,
    SUBMIT_EDIT_CUSTOMER_PROFILE,
    FILL_CUSTOMER_PROFILE_DETAILS,
    HANDLE_DATE_OF_BIRTH_CUSTOMER,
    SET_CUSTOMER_PROFILE_IMAGE_FILE,
    CHANGE_CUSTOMER_PROFILE_SET
} from '../constants/ActionTypes';

export const changeCustomerProfile = payload => ({
    type: SUBMIT_EDIT_CUSTOMER_PROFILE,
    payload,
  });
  export const changeCustomerProfileSet = () => ({
      type:CHANGE_CUSTOMER_PROFILE_SET
  })

  export const requestCustomerData = () =>({
      type:REQUEST_CUSTOMER_DATA
  })

 export const fillCustomerProfileDetails = () =>({
     type:FILL_CUSTOMER_PROFILE_DETAILS
 })


 export const handleDateOfBirthCustomer = payload => ({
    type: HANDLE_DATE_OF_BIRTH_CUSTOMER,
    payload,
  });

  export const setCustomerProfileImageFile =payload => ({
      type:SET_CUSTOMER_PROFILE_IMAGE_FILE,
      payload
  })


// WEBPACK FOOTER //
// ./actions/CustomerProfile.js